/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect, useContext } from 'react'
import { PageFooterWrapper } from '@usb-ui-tools/react-billpay-layout'
import FindbillsHeader from '../../../modules/payees/findbills/header/findbills-header'
import ReadyToAddBills from '../../../modules/payees/findbills/readyToAdd/readyToAddBills'
import { BASE_PATH } from '../../../config/connections'
import routerpath from '../../../constants/routerpath'
import { appCache } from '../../../context/appCache'
import {
  isOLBOrIpadApp,
  isTuxApp,
  navigateRoute
} from '../../../utils/browserutils'
import { PageviewTealiumEvent } from '../../../utils/tealiumwrapper'
import { PAGE_NAMES } from '../../../constants/tealiumData'
import { useGetBillerDiscoveryService } from '../../../service/payees/billDiscovery/getBillerDiscovery.service'
import { useSearchDashboadService } from '../../../service/payees/add/dashboard.service'
import { useMultilingualService } from '../../../service/multilingualService'
import Loader from '../../../components/spinner'
import DashboardSearchBills from '../../../modules/payees/add/dashboard/search-bills/search-bills'
import {
  getbillerCache,
  payeeDashbord,
  searchedBillerDetails,
  selectedBillerDetails
} from '../../../graphql/cache/localCache'
import {
  getverifiedBillsPayload,
  ProductCode,
  redirectToDashboard
} from '../../../utils/verifyBills'
import ErrorComponent from '../error'
import { useVerifyPotentialService } from '../../../service/payees/verify_potential.service'
import './findbills.scss'
import MobileBillPayLayout from '../../../modules/layout/MobileBillPayLayout'
import handleFindBillError from '../../../utils/handleFindBillError'
import { LoaderContext } from '../../../context/LoaderContext'
import {
  getSessionStorageValue,
  setSessionStorageValue
} from '../../../utils/sessionUtils'
import { updateOnboardingFeatureNew } from '../../../utils/poaUtils'
import { OnboardingSuccessInfoLogger } from '../../../utils/loggerUtils'
import { serachPayloadData } from '../../../utils/processData'
import { NativeInterfaceHandler } from '../../../utils/nativeHandlers'
import SearchFindPopup from '../../../modules/payees/add/dashboard/searchFindPopUp'

const FindBillsContainer = () => {
  const [minchar] = useState(3)
  const [pageErrorMsg, setPageErrorMsg] = useState('')
  const [isSystemError, setSystemError] = useState(false)
  const [isFieldsValidationError, setFieldsValidationError] = useState(false)
  const footerRef = useRef()
  const { navigateRoutePath } = navigateRoute()
  const [verifiedBills, setVerifiedBills] = useState([])
  const [nonVerifiedBills, setNonVerifiedBills] = useState([])
  const [searchVal, setSearchVal] = useState('')
  const [subText, setSubText] = useState('')
  const [selBill, setSelBill] = useState({})
  const [selPopUp, setSelPopUp] = useState('')
  const [reviewModal, setReviewModal] = useState({})
  const autocompleteRef = useRef()
  const { showLoader = false, setShowLoader = null } = useContext(
    LoaderContext || {}
  )
  const { selectedBill = {} } = selectedBillerDetails() || {}
  const {
    called,
    billerDiscoveryLoading,
    dataBD,
    billerDiscoveryError,
    payeeList,
    loadBillerDiscovery
  } = useGetBillerDiscoveryService()
  const {
    loadApi,
    loading,
    error,
    searchBillData,
    data: searchBillDataResp
  } = useSearchDashboadService(false)

  /* Check onboardingDeeplink */
  let fromOnboarding = false
  const onboardingDeeplink = JSON.parse(
    getSessionStorageValue('onboardingBillpayDeeplink')
  )
  if (
    onboardingDeeplink &&
    onboardingDeeplink?.source === 'digitalOnboarding'
  ) {
    fromOnboarding = true
  }
  setSessionStorageValue('fromOnboarding', fromOnboarding)

  useEffect(() => {
    payeeDashbord({ isDashboard: false })
  }, [payeeDashbord])
  const {
    loadApi: addPotentialPayee,
    loading: isPotentialPayeeLoading,
    error: isPotentialPayeeError,
    data: potentialData
  } = useVerifyPotentialService()
  const sortedList = (billerList) => {
    billerList.sort((a, b) =>
      a.merchantData.billerName.localeCompare(b.merchantData.billerName)
    )
    return billerList
  }
  const handleSearchKeyPress = (val) => {
    loadApi({
      variables: serachPayloadData(false, val)
    })
  }
  useEffect(() => {
    if (searchVal.length === 0) {
      setSearchVal('')
      setSubText('')
    }
    if (searchVal && searchVal.length >= minchar) {
      const intiVal = searchVal.substr(0, minchar)

      if (intiVal !== subText) {
        handleSearchKeyPress(searchVal)
        setSubText(intiVal)
      }
    }
  }, [searchVal, handleSearchKeyPress, minchar, subText])
  const redirectAddBillInfoSearch = (item) => {
    setSelBill(item)
    const input = document.querySelector(
      '#add-bill-dashboard-search-input1 > input'
    )
    input?.blur()
    setSelPopUp('searchBillConfirm')
    const cURI = item ? item.billerSiteUrl : ''
    const dashboardData = selectedBill?.payeeData
    const isSelBillDashboard =
      dashboardData &&
      dashboardData.some(
        (el) => el?.billPayPayee?.biller?.merchantAlias === cURI
      )
    const name = item?.billerName?.toLowerCase?.()
    const dataList =
      dashboardData &&
      dashboardData.filter((el) => {
        if (el?.billPayPayee?.isPayeeInternal) {
          if (name === 'us bank credit card') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_CCD ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_BCD ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_EXL
            )
          }
          if (name === 'us bank loans') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_BLN ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_SLN ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_UNL
            )
          }
          if (name === 'us bank lease') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_LEA
            )
          }
          if (name === 'us bank lineofcredit') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_LOC
            )
          }
          if (name === 'us bank mortgage') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_ADP ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_MAL
            )
          }
          if (name === 'us bank') {
            return (
              el && el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode
            )
          }
        }
        return false
      })

    if (isSelBillDashboard || (dataList && dataList.length > 0)) {
      NativeInterfaceHandler('PopUpHandler', true)
      const inputt = document.querySelector(
        '#add-bill-dashboard-search-input1 > input'
      )
      inputt?.blur()
      setReviewModal({ openReviewModal: true })
    } else {
      navigateRoutePath(`${BASE_PATH}${routerpath.pages.search}`)
    }
  }
  const setTypeaheadVal = (event) => {
    const selBillList =
      searchBillData && searchBillData.filter((el) => el.id === event.id)
    const pURI =
      selBillList && selBillList?.length > 0 ? selBillList[0].billerSiteUrl : ''
    const selTypeAheadBillList =
      searchBillDataResp &&
      searchBillDataResp?.billpayPayeeListInquiry &&
      searchBillDataResp?.billpayPayeeListInquiry?.billerList?.filter(
        (item) =>
          (item && item.billerSiteUrl ? item.billerSiteUrl : '') === pURI
      )
    const logoURL =
      selTypeAheadBillList && selTypeAheadBillList?.length > 0
        ? selTypeAheadBillList[0].billerLogoUrl
        : ''
    searchedBillerDetails({
      billerName: event.value,
      billerZipRequired: event.billerZipRequired,
      billerSiteUrl: event.billerSiteUrl,
      billerLogoUrl: event.billerLogoUrl || logoURL
    })
    redirectAddBillInfoSearch(
      (selTypeAheadBillList && selTypeAheadBillList[0]) || {}
    )
  }
  useEffect(() => {
    document.title = 'Find bills'
    appCache({ ...appCache(), Title: 'Find bills' })
    loadBillerDiscovery({
      variables: {
        appName: 'BILLPAY',
        billpayPayeeListInquiryRequest: {
          isCustomerConsentGiven: true
        }
      }
    })
  }, [])
  useEffect(() => {
    if (payeeList) {
      const verifiedBillsList = []
      const nonVerifiedBillsList = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < payeeList?.length; i++) {
        if (payeeList?.[i]?.isAdditionalInfoRequired) {
          nonVerifiedBillsList.push(payeeList[i])
        } else {
          verifiedBillsList.push(payeeList[i])
        }
      }
      setVerifiedBills(sortedList(verifiedBillsList))
      setNonVerifiedBills(sortedList(nonVerifiedBillsList))

      const reportingData = {
        consentPopup: false,
        noBills: false,
        transactionStatus: 'omni bill pay find bill start'
      }
      PageviewTealiumEvent(PAGE_NAMES.FIND_BILL_DASHBOARD, reportingData)
    } else if (
      called &&
      !billerDiscoveryLoading &&
      (payeeList === null || payeeList.length > 0)
    ) {
      const reportingData = {
        consentPopup: false,
        noBills: true
      }
      PageviewTealiumEvent(PAGE_NAMES.FIND_BILL_DASHBOARD, reportingData)
    }
  }, [payeeList])
  const handleFooterClick = (event, type) => {
    if (event && type === 'yes') {
      if (payeeList?.length > 0) {
        if (nonVerifiedBills?.length > 0) {
          getbillerCache({ verifiedBills, nonVerifiedBills })
          navigateRoutePath(`${BASE_PATH}${routerpath.pages.verifybills}`)
        } else {
          const verifiedPayeesParameters =
            getverifiedBillsPayload(verifiedBills)
          if (verifiedPayeesParameters?.length > 0) {
            setShowLoader(true)
            addPotentialPayee({
              variables: {
                appName: 'BILLPAY',
                verifyPotentialPayeeRequest: {
                  verifyPayeesParameters: [...verifiedPayeesParameters]
                }
              }
            })
          }
        }
      } else {
        navigateRoutePath(`${BASE_PATH}${routerpath.pages.manual}`)
      }
    } else if (event && type === 'no') {
      if (fromOnboarding) {
        window.location.href = `${onboardingDeeplink.redirectUrl}/billpay`
      } else {
        navigateRoutePath(`${BASE_PATH}${routerpath.pages.payeedashboard}`)
      }
    }
  }
  useEffect(() => {
    if (isPotentialPayeeError) {
      setShowLoader(false)
    }
  }, [isPotentialPayeeError])
  const handleSuccess = () => {
    OnboardingSuccessInfoLogger('DIY_BILLPAY', 'FIND_BILL_SUCCESS')
  }
  const handleFailure = () => {
    OnboardingSuccessInfoLogger('DIY_BILLPAY', 'FIND_BILL_FAILED')
  }
  useEffect(() => {
    const callPoaAndNavigateToDashboard = async () => {
      if (
        !isPotentialPayeeLoading &&
        !isPotentialPayeeError &&
        potentialData?.verifyPotentialPayee?.verifiedPayees?.length
      ) {
        // update POA here for onboarding, verify payee success
        if (fromOnboarding) {
          await updateOnboardingFeatureNew(handleSuccess, handleFailure)
          setSessionStorageValue('isBillpaySuccess', 'true')
        }
        redirectToDashboard(
          potentialData?.verifyPotentialPayee?.verifiedPayees?.length
        )
      }
    }
    callPoaAndNavigateToDashboard()
  }, [potentialData])
  useEffect(() => {
    handleFindBillError(billerDiscoveryError, setSystemError)
    const reportingData = {
      consentPopup: false,
      noBills: true
    }
    if (billerDiscoveryError?.message) {
      PageviewTealiumEvent(PAGE_NAMES.FIND_BILL_DASHBOARD, reportingData)
    }
  }, [billerDiscoveryError])
  const handleBillerRemoval = (billerType, payeeId) => {
    const billerArr =
      billerType === 'verified' ? verifiedBills : nonVerifiedBills
    const billerToBeRemoved = billerArr.findIndex(
      (obj) => obj.payeeId === payeeId
    )
    billerArr.splice(billerToBeRemoved, 1)
    if (billerType === 'verified') {
      setVerifiedBills([...sortedList(billerArr)])
    } else setNonVerifiedBills([...sortedList(billerArr)])
  }
  const { FOOTER, SEARCH_FIND } = useMultilingualService('findbills')
  const getBillTextCTA = () => {
    if (nonVerifiedBills && nonVerifiedBills?.length > 0) {
      const billText =
        nonVerifiedBills?.length === 1 ? FOOTER?.BILL : FOOTER?.BILLS
      return `${FOOTER?.ADD} ${nonVerifiedBills?.length} ${billText}`
    }
    const billTextver =
      verifiedBills?.length === 1 ? FOOTER?.BILL : FOOTER?.BILLS
    return `${FOOTER?.ADD} ${verifiedBills?.length} ${billTextver}`
  }
  if (billerDiscoveryLoading || isPotentialPayeeLoading || showLoader) {
    return <Loader />
  }
  return (
    <>
      {!isSystemError && (
        <PageFooterWrapper
          isOLBOrIpadApp={isOLBOrIpadApp}
          ref={footerRef}
          id="find-bill-footer"
          buttonOptions={[
            {
              type: 'primary',
              text:
                payeeList?.length > 0 ? getBillTextCTA() : FOOTER?.ADD_MANUALLY,
              clickEvent: (e) => {
                handleFooterClick(e, 'yes')
              },
              show: true,
              id: 'find-bill-footer--yes'
            },
            {
              type: 'text',
              text: `${FOOTER?.CANCEL}`,
              clickEvent: (e) => {
                handleFooterClick(e, 'no')
              },
              show: true,
              id: 'find-bill-footer--no '
            }
          ]}
          otherBlockProps={{ compact: !(payeeList?.length > 0) }}
        >
          <div
            style={{ width: '100%' }}
            // additionalClasses={['combined-styles']}
          >
            {isTuxApp() && <MobileBillPayLayout />}
            <FindbillsHeader
              {...{
                isFieldsValidationError,
                pageErrorMsg,
                payeeList
              }}
            />
            {payeeList?.length > 0 ? (
              <ReadyToAddBills
                verifiedBills={verifiedBills}
                nonVerifiedBills={nonVerifiedBills}
                handleBillerRemoval={handleBillerRemoval}
              />
            ) : (
              <DashboardSearchBills
                {...{
                  setSearchVal,
                  searchBillData,
                  setTypeaheadVal,
                  loading,
                  autocompleteRef
                }}
              />
            )}
            {reviewModal && reviewModal?.openReviewModal === true && (
              <SearchFindPopup
                {...{
                  selBill,
                  selPopUp,
                  reviewModal,
                  autocompleteRef,
                  payeeData: selectedBill?.payeeData,
                  setReviewModal,
                  lang: SEARCH_FIND
                }}
              />
            )}
          </div>
        </PageFooterWrapper>
      )}
      {isSystemError && <ErrorComponent />}
    </>
  )
}
export default FindBillsContainer
